/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'scripts';
const componentName = 'data-script';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const eventTypesLabel = `${prefix}.eventTypesLabel`;
export const successfulCloneHeader = `${prefix}.successfulCloneHeader`;
export const successfulCloneMessage = `${prefix}.successfulCloneMessage`;

export const ENGLISH = {
    [headerLabel]: 'DataScripts',
    [eventTypesLabel]: 'Event Types',
    [successfulCloneHeader]: 'Successfully cloned',
    [successfulCloneMessage]: 'The DataScript should appear in the table shortly.',
};
